import { Box, Typography } from "@mui/material";
import React from "react";
import LOGO from "assets/images/logo.png";
import UserListComponent from "./UserListComponent";

const InvoiceHeader = ({ data, isReceipt }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ width: "50%" }}>
        <Typography sx={{ fontSize: 16, fontWeight: 600 }} color="grey">
          From
        </Typography>
        <Typography sx={{ fontSize: 22, fontWeight: 600 }}>
          Super Gym
        </Typography>

        <UserListComponent title="TRN" data="100385469000003" />
        <UserListComponent
          title="Address"
          data="Blue Diamond building . shop 02.03.04. al qusais industreial
                  are 5"
        />
        <UserListComponent title="Phone" data="97142808088" />
        <UserListComponent title="Email" data="  dxb.supergym01@gmail.com" />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          width: "40%",
        }}
      >
        <Typography sx={{ fontSize: 25, fontWeight: 600 }}>
          TAX {isReceipt ? "RECEIPT" : "INVOICE"} : {data?.objectId}
        </Typography>
        <Box sx={{ height: 100, width: 100 }}>
          <img src={LOGO} style={{ height: "100%", width: "100%" }} />
        </Box>
      </Box>
    </Box>
  );
};

export default InvoiceHeader;
